/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  AppCardListService,
  IAppCardListMethods,
  ILoadingMethods,
  LoadingService,
  StaticPageContentService,
  IStaticPageContentMethods,
  AddGroupService,
  IAddGroupMethods,
} from "./components";

export type HolderGroupPageAgent = IStaticPageContentMethods &
  IHeaderMethods &
  ISettingsMethods &
  IAppCardListMethods &
  IAddGroupMethods &
  ILoadingMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new AppCardListService(),
    new LoadingService(),
    new AddGroupService(),
  ];
};

export const getAgent = () => {
  return createAgent<HolderGroupPageAgent>({
    plugins: getPlugins(),
  });
};
